// extracted by mini-css-extract-plugin
module.exports = {"inputShift":"xlXeu","error":"_15EGr"};